module.exports = __webpack_public_path__ + "static/img/ekwan.c947dfd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonial/ekwan.jpeg
// module id = yLFy
// module chunks = 1